module.exports = __webpack_public_path__ + "static/media/route.99607ac6.svg";